<div class="detail-page">

  <div class="detail-header">
    <a class="back-btn" routerLink="/profile">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <h1 class="detail-title">{{ shopname }}</h1>
    <button mat-icon-button class="delete-btn" (click)="deleteShop()" title="Verwijder winkel">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <p class="section-label">Volgorde categorieën</p>
  <p class="section-hint">Sleep de categorieën in de gewenste volgorde.</p>

  <div class="drag-list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (cat of categories; track cat.id) {
      <div class="drag-row" cdkDrag>
        <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
        <span class="cat-name">{{ cat.name }}</span>
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
      </div>
    }
  </div>

  @if (categories.length === 0) {
    <div class="empty-state">
      <mat-icon>category</mat-icon>
      <p>Geen categorieën gevonden</p>
    </div>
  }

  <button class="save-btn" mat-flat-button (click)="saveOrder()">
    @if (saved) {
      <ng-container><mat-icon>check</mat-icon> Opgeslagen</ng-container>
    } @else {
      Sla volgorde op
    }
  </button>

</div>
